import { render, staticRenderFns } from "./CloneSegment.vue?vue&type=template&id=ca85bbbc"
import script from "./CloneSegment.vue?vue&type=script&lang=js"
export * from "./CloneSegment.vue?vue&type=script&lang=js"
import style0 from "./CloneSegment.vue?vue&type=style&index=0&id=ca85bbbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports